import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, NgZone, ViewEncapsulation } from '@angular/core';
import { ButtonTriggerEvent } from '../../../common/components';
import { HubApiService } from '../../../services/hub.api.service';
import { ImageService } from '../../../services/image.service';
import { BaseComponent } from '../../../common/components/base.component';
import { AlertifyService } from '../../../services/alertify.service';
import { HubPlace } from '../../../models/hub/hub.place';
import { BulkAIDescriptionsStore } from '../../../stores/hub.calendar.store';
import { ConfirmModalActions, ConfirmModalData } from '../../../common/components/confirm.modal/confirm.modal.provider';
import { ConfirmModalComponent } from '../../../common/components/confirm.modal/confirm.modal.component';
import { ModalService } from '../../../common/services/modal.service';

@Component({
  selector: 'ig-bulk-ai-descriptions-modal',
  templateUrl: './bulk.ai.descriptions.modal.component.html',
  styleUrls: ['./bulk.ai.descriptions.modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkAIDescriptionsModalComponent extends BaseComponent {
  public hubName: string;
  public places: HubPlace[] = [];
  isCornerView = false;
  progress = 0;
  context = ''; // city name for AI as context
  isCancel = false;
  isAskForCancel = false;
  isCommandReceived = false;

  constructor(
    public imageService: ImageService,
    public cdRef: ChangeDetectorRef,
    private hubApiService: HubApiService,
    private bulkAIDescriptionsStore: BulkAIDescriptionsStore,
    private modalService: ModalService,
    private alertify: AlertifyService
  ) {
    super();

    bulkAIDescriptionsStore.bulkAIDescriptionsCommand.subscribe((command) => {
      // avoid this receives multiple commands when you close and open this modal multiple times
      if (this.isCommandReceived) return;
      this.isCommandReceived = true;

      this.hubName = command;
      this.hubApiService.getNoDescriptionPlaces(this.hubName).subscribe((places) => {
        console.log(places);
        this.places = places;
        this.cdRef.detectChanges();

        // get the city name of these places
        if (places.length) {
          const place = places.first((place) => !!place.address_components);
          if (place && place.address_components) {
            this.context = this.getPlaceCity(place);
            console.log('context', this.context);
          }
        }
      });
    });
  }

  public async confirm(event: ButtonTriggerEvent) {
    this.isCornerView = true;
    this.progress = 1; // set progress to 1 so that we can display some relates UI elements to indicate the status
    this.cdRef.detectChanges();

    // group this.places to 10 items
    const groupedPlaces: any[] = [];
    for (let i = 0; i < this.places.length; i += 10) {
      const group = this.places.slice(i, i + 10);
      groupedPlaces.push(group);
    }
    console.log('groupedPlaces', groupedPlaces);

    const start = new Date().getTime();
    let index = 1;
    for (const group of groupedPlaces) {
      if (this.isCancel) {
        console.log('cancel');
        return;
      }

      const result = await this.hubApiService
        .aiAssistant(this.hubName, {
          context: this.context,
          query: group.map((p) => `{"name": "${p.name}, ${this.getPlaceCity(p)}", "id": "${p._id}"}`).join('; '),
          feature: 'bulk-place-descriptions',
        })
        .toPromise();

      if (result.success) {
        const data = result.data.replace(/\\n/i, '');
        const json = JSON.parse(data);
        console.log(json);
        Object.keys(json).forEach((key) => {
          let place = this.places.find((x) => x._id.toString() === key.toString());
          place && (place.description = json[key]);
          console.log(place);
        });
      }

      // calculate the progress, max value is 100
      this.progress = (index / groupedPlaces.length) * 100;
      this.cdRef.detectChanges();

      console.log('this.progress', this.progress);
      index++;
    }
    const end = new Date().getTime();
    console.log(`${(end - start) / 1000} sec`);
  }

  public async save(event: ButtonTriggerEvent) {
    // trigger the loading animation
    this.cdRef.detectChanges();

    // save places by grouping to avoid request too large error
    const groupSize = 200;
    let index = 0;
    try {
      while (index < this.places.length) {
        const group = this.places.slice(index, index + groupSize);
        await this.hubApiService.savePlacesDescriptions(this.hubName, group).toPromise();
        index += groupSize;
      }
      this.close();
      this.alertify.success('Place descriptions saved!');
    } catch (error) {
      this.alertify.error(error.message);
    } finally {
      event.complete();
    }
  }

  public checkStatus() {
    this.isCornerView = false;
    this.cdRef.detectChanges();
  }

  public hide() {
    this.isCornerView = true;
    this.cdRef.detectChanges();
  }

  public close(): void {
    if (this.progress > 0 && this.progress < 100 && !this.isCancel) {
      this.hide();
      return;
    }
    const modal = document.querySelector('ig-bulk-ai-descriptions-modal');
    modal && modal.remove();
  }

  public cancel() {
    this.isCancel = true;
    this.alertify.success('Place descriptions generation cancelled!');
    this.close();
  }

  public askForCancel() {
    this.isAskForCancel = true;
    this.cdRef.detectChanges();
  }

  public get displayProgress() {
    return Math.round(this.progress) + '%';
  }

  private getPlaceCity(place: HubPlace) {
    if (place.address_components) {
      const level1 = place.address_components.find((x) => x.types.any((y) => y === 'administrative_area_level_1'));
      const locality = place.address_components.find((x) => x.types.any((y) => y === 'locality'));
      const context = level1 && locality ? `${locality.long_name}, ${level1.long_name}` : '';
      return context;
    }
    return '';
  }

  private myWait(milSeconds) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(null);
      }, milSeconds);
    });
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/bulk.ai.descriptions.modal/bulk.ai.descriptions.modal.component.ts